import React, { useState, useEffect } from 'react';
import AsideLeft from './AppAdminComponents/AsideLeft';
import NavBarNotificationBar from './AppAdminComponents/NavBarNotificationBar';
import { getuser } from '../helpers/user.helper';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useNavigate, useParams } from "react-router-dom";
import {  GetItemsKit } from '../services/kit.service';
import formatDate from '../helpers/date.helper';

import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';
import { BiLoaderCircle } from 'react-icons/bi';
import Footer from '../components/Footer';
import formatMoney from '../helpers/money.helper';

export default function KitItens() {
    let navigate = useNavigate();
    const [kitsItems, setItems] = useState([]);

    let { id } = useParams();

    useEffect(() => {
        let user = getuser();
        //Redireciona caso não esteja logado 
        if (!user) {
            navigate('/login');
        }        

        async function fetchData() {

            let array_response = await GetItemsKit(id);
            setItems(array_response?.data);
        }

        fetchData();
    }, []);

    const IconLoader = () => {
        return <BiLoaderCircle className="loader-icon" />;
    };

    return (
        <>
            <div className="wrapper">
                {/* Navbar */}
                <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                    <NavBarNotificationBar />

                </nav>
                <AsideLeft option="kits" />

                <>
                    <div className="content-wrapper">
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-6">
                                        <h1 className="m-0 text-dark">Itens do Kit</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    {/* Left col */}
                                    <section className="col-lg-12 connectedSortable">
                                        {/* Custom tabs (Charts with tabs)*/}
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title">
                                                    <i className="fas fa-chart-pie mr-1" />Kit Pedido {id}
                                                </h3>
                                            </div>
                                            <div className="card-body">
                                                <div className="tab-content p-0">
                                                    <DataTable
                                                        value={kitsItems}
                                                        style={{ marginBottom: 50 }}
                                                        responsive className="p-datatable-customers"
                                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                        currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                                                        paginator="true"
                                                        rowsPerPageOptions={[10, 20, 50]}

                                                        rows={10}
                                                        emptyMessage={<IconLoader />}
                                                    >
                                                        <Column field="codigoproduto" header="Cód do produto" filter={true} />
                                                        <Column field="codmovenda" header="Cód da Venda" filter={true} />
                                                        <Column field={(row) => formatDate(row.data)} header="Data" />
                                                        <Column field={(row) => formatMoney(row.valortotal)} header="Valor" />
                                                        <Column key="123" field="descricaoproduto" header="Descrição" bodyStyle={{ textAlign: 'center', overflow: 'hidden' }} />
                                                    </DataTable>
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                </div>
                            </div>
                        </section>
                    </div>
                </>
                <Footer />
            </div>
        </>
    )
}
